import { compareAsc, compareDesc } from "date-fns/esm";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";
import Dated from "@mapmycustomers/shared/types/base/Dated";
import Identified from "@mapmycustomers/shared/types/base/Identified";
import Named from "@mapmycustomers/shared/types/base/Named";
import User from "@mapmycustomers/shared/types/User";

import SortField from "@app/component/ListDrawer/enum/SortField";

const getFilteredSavedFilters = <T extends Identified & Named & Dated<Date> & { user?: User }>(
  search: string,
  items: T[],
  sortField: SortField,
  sortOrder: SortOrder,
  creatorIds: User["id"][]
) => {
  const query = search.trim().toLowerCase();

  const filteredSavedFilters = items.filter(
    ({ name, user }) =>
      (!query || name.toLowerCase().includes(query)) &&
      (!creatorIds.length || !user?.id || creatorIds.includes(user.id))
  );
  const dateComparator = sortOrder === SortOrder.ASC ? compareAsc : compareDesc;
  return filteredSavedFilters.sort((row1, row2) =>
    dateComparator(row1[sortField], row2[sortField])
  );
};

export default getFilteredSavedFilters;
